<template>
    <div>
        <v-card class="rounded-lg" color="#41916b" elevation="0">
            <v-tabs fixed-tabs background-color="#41916b" dark>
                <v-tabs-slider color="#ceded0"></v-tabs-slider>
                <v-tab>{{ $t('titles.new_exam_title') }}</v-tab>

                <v-tab-item>
                  <v-card flat>
                    <v-card-text>
                        <v-form @submit.prevent="exameDonorForm" ref="form">
                            <v-container>
                                <p style="font-weight:bold">Paciente: {{ resource.name }}</p>
                            </v-container>
                            <ExamesEntradaForm />
                        </v-form>
                    </v-card-text>
                  </v-card>      
                </v-tab-item>

            </v-tabs>
        </v-card>
        <v-snackbar absolute background-color="white" color="#40a374" v-model="snackbar">
            {{ message }}
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
                Fechar
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>
  
<script>
import ExamesEntradaForm from './CadastrarExamesEntrada-comp.vue';
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            dialog: false,
            activateButtons: false,
            displayError: {
                display: false,
                message: [],
            },
            loading: true,
            options: {},
            message: "",
            snackbar: false,
            messageError: "",
            donorData: "",
            donorID: "",
            donor_name: "",
            entrace_exams: [],
        };
    },

    computed:{
        ...mapGetters({
            resource: "getPatientData"
        }),
    },

    methods: {},

    mounted() {},

    components:{
        ExamesEntradaForm
    }

};
</script>
  
<style scoped>

.deathDialog>h4{
    color: #413f3f;
    padding: 20px;
}
.text-h5{
    background-color: #50c78f;
    color: white;
    text-shadow: 1px 2px 2px #309171
}
.donorIcon{
    padding:  8px 8px 8px 0;
}
.header-table {
    display: flex;
    margin-bottom: 20px;
}

p{
    font-size: 16px;
    /* font-weight: bold; */
}
.d-flex {
    padding: 0 6px;
}

.space {
    width: 5px;
}

.space-personalized {
    padding: 4px;
}

.spacediferent {
    width: 7px;
}

.v-btn:not(.v-btn--round).v-size--default {
    height: 40px !important;
}

.textBtn {
    font-family: "Poppins";
    color: #ffffff;
}

.create-user-dialog {
    padding: 20px;
}

.card {
    padding: 35px;
}

.banner {
  background: #b3ffab;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right,
      #0ca673,
      #1abc9c);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right,
      #0cb087,
      #66f9b9);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.textBtn{
  color:#ffffff;
}
.banner>h3 {
  color: #ffffff;
  padding: 18px 0 18px 0;
}
.modalIcon{
  padding: 12px;
}

 .cardFooter {
    padding: 0 !important;
}
</style>
  